var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import $request from '../../utils/request';
var state = {
    insCompanyList: [],
    insMainCompanyCodeList: [],
    rentCompanyList: [],
    cityList: [],
};
var mutations = {
    update: function (state, props) {
        for (var key in props) {
            if (state.hasOwnProperty(key)) {
                state[key] = props[key];
            }
        }
    },
};
var actions = {
    GET_CITY_LIST: function (_a, params) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        $request({
            url: '/proxy/carInsurance/area/query',
            method: 'get',
            data: params,
        }).then(function (res) {
            if (res.errorCode) {
                return;
            }
            var ds = res.data;
            if (Array.isArray(res.data) && res.data.length === 1 && res.data[0].id === 1) {
                ds = res.data[0].children;
            }
            commit('update', {
                cityList: ds,
            });
        });
    },
    GET_INS_COMPANYS: function (_a, params) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        $request({
            url: '/proxy/insClaim/statistics/common/insuranceCompany',
            method: 'post',
            data: __assign({}, params),
        }).then(function (res) {
            if (!res.errorCode) {
                var dataset_1 = [];
                var mainInsCode_1 = [];
                res.data.insCompanyFirstList.forEach(function (insCompany) {
                    var dtItemChildren = [];
                    if (insCompany.insCompanySecondList) {
                        insCompany.insCompanySecondList.forEach(function (sItem) {
                            dtItemChildren.push({
                                label: sItem.inscompanyCodeName || sItem.inscompanyCode.toString(),
                                id: sItem.inscompanyCode,
                            });
                        });
                    }
                    mainInsCode_1.push(insCompany.inscompanyCode);
                    dataset_1.push({
                        label: insCompany.inscompanyCodeName || insCompany.inscompanyCode.toString(),
                        id: insCompany.inscompanyCode,
                        children: dtItemChildren,
                    });
                });
                commit('update', {
                    insCompanyList: dataset_1,
                    insMainCompanyCodeList: mainInsCode_1,
                });
            }
        });
    },
    GET_RENT_COMPANYS: function (_a, params) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        $request({
            url: '/proxy/insClaim/statistics/common/rentalCompany',
            method: 'post',
            data: __assign({}, params),
        }).then(function (res) {
            if (!res.errorCode && res.data && res.data.rentalCompanyList) {
                var options_1 = [];
                res.data.rentalCompanyList.forEach(function (item) {
                    options_1.push({
                        label: item.rentalCompanyName || item.rentalCompanyCode.toString(),
                        value: item.rentalCompanyCode,
                    });
                });
                commit('update', {
                    rentCompanyList: options_1,
                });
            }
        });
    },
};
export default {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
};
